import * as React from "react";
import { Box } from "@mui/material";
import AddCover from "../subPage/AdditionalResearch/AddCover";
import AddDescriptionDocument from "../subPage/AdditionalResearch/AddDescriptionDocument";
import { LOCAL_CONSTANT } from "../Const";

interface AdditionalResearchProps {
    props: {};
}

const AdditionalResearch: React.FC<AdditionalResearchProps> = ({ props }) => {
    return (
        <Box sx={{ width: "100%", margin: "30px" }}>
            <AddCover
                props={{
                    menuLabel: LOCAL_CONSTANT.LABEL.COVER_REFERENCE,
                    correctionLabel: "承認済み参考値を修正する",
                    addButton: "add_survey_cover_reference",
                    comenntButton: "add_survey_cover_reference_fixes",
                }}
            />
            <AddCover
                props={{
                    menuLabel: LOCAL_CONSTANT.LABEL.COVER_CONFIRMED,
                    correctionLabel: "承認済み確定値を修正する",
                    addButton: "add_survey_cover_confirmed",
                    comenntButton: "add_survey_cover_confirmed_fixes",
                }}
            />
            <AddDescriptionDocument props={{}} />
        </Box>
    );
};

export default AdditionalResearch;
